import { create } from 'zustand';

interface Integration {
  IntegrationName: string;
  OrgUUID: string;
  AccessToken: string;
  InstanceURL: string;
  GithubUserName?: string;
  GitlabUserName?: string;
  BitbucketUserName?: string;
  CloudId?: string;
  UserUUID: string;
}

interface UserAuthIntegrationsState {
  integrations: Integration[];
  addIntegration: (integration: Integration) => void;
  removeIntegration: (integrationName: string, userUUID: string) => void;
  updateIntegration: (integration: Integration) => void;
  getIntegrationByName: (
    integrationName: string,
    userUUID: string
  ) => Integration | undefined;
  setInitialIntegrations: (initialIntegrations: Integration[]) => void;
}

const useUserAuthIntegrationsStore = create<UserAuthIntegrationsState>(
  (set, get) => ({
    integrations: [],

    addIntegration: (integration) =>
      set((state) => ({
        integrations: [...state.integrations, integration],
      })),

    removeIntegration: (integrationName, userUUID) =>
      set((state) => ({
        integrations: state.integrations.filter(
          (i) =>
            !(i.IntegrationName === integrationName && i.UserUUID === userUUID)
        ),
      })),

    updateIntegration: (updatedIntegration) =>
      set((state) => ({
        integrations: state.integrations.map((integration) =>
          integration.IntegrationName === updatedIntegration.IntegrationName &&
          integration.UserUUID === updatedIntegration.UserUUID
            ? { ...integration, ...updatedIntegration }
            : integration
        ),
      })),

    getIntegrationByName: (integrationName, userUUID) => {
      return get().integrations.find(
        (i) => i.IntegrationName === integrationName && i.UserUUID === userUUID
      );
    },

    setInitialIntegrations: (initialIntegrations) =>
      set(() => ({
        integrations: initialIntegrations,
      })),
  })
);

export default useUserAuthIntegrationsStore;
